import './headless-scene-components.js'

import { ReferenceMap, create, error } from '@hatiolab/things-scene'
import { client, gqlContext, subscribe } from '@operato/graphql'

import gql from 'graphql-tag'

export { BoardViewer } from '../board/index.js'

export const provider = new ReferenceMap(
  async (boardId, resolve, reject) => {
    try {
      const response = await client.query({
        query: gql`
          query FetchBoardById($id: String!) {
            board(id: $id) {
              model
            }
          }
        `,
        variables: { id: boardId },
        context: gqlContext()
      })

      const board = response.data.board

      var model = JSON.parse(board.model)

      var scene

      try {
        scene = await provider.get(boardId)
        console.warn('Board fetched more than twice.', boardId)
      } catch (e) {
        scene = create({
          model,
          mode: 0,
          refProvider: provider
        })

        // s.app.baseUrl = undefined;
      }

      resolve(scene)

      // resolve(scene, {
      //   ...board,
      //   model
      // })
    } catch (e) {
      error(e)
      reject(e)
    }
  },
  async (id, ref) => {
    ref.dispose()
  }
)

var subscriptionForAutoRefresh

export const startSubscribingForAutoRefresh = async (boardId, callback) => {
  if (!boardId) {
    return
  }

  await stopSubscribing()

  subscriptionForAutoRefresh = await subscribe(
    {
      query: gql`
        subscription ($id: String!) {
          board(id: $id) {
            id
            model
          }
        }
      `,
      variables: {
        id: boardId
      }
    },
    {
      next: async ({ data }) => {
        const { id, model = '{}' } = data.board

        if (data) {
          callback &&
            (await callback({
              id,
              model: JSON.parse(model)
            }))
        }
      }
    }
  )
}

export const stopSubscribing = async () => {
  await subscriptionForAutoRefresh?.unsubscribe()
  subscriptionForAutoRefresh = null
}

window['headlessSceneProvider'] = provider
window['startSubscribingForAutoRefresh'] = startSubscribingForAutoRefresh
window['stopSubscribing'] = stopSubscribing
